import {Action} from '@ngrx/store';
import {BijbError} from '../../../models/bijb-error';

export class GetCurrentUserErrorAction implements Action {
  public static readonly type = 'GetCurrentUserErrorAction';

  constructor(public error: BijbError) {
  }

  public type = GetCurrentUserErrorAction.type;
}
